const InputWithErrorMessage = ({
    value,
    errMsg = "",
    onChange,
    size=40
}) => {
    return (
    <>
        <input
            type="text"
            size={size}
            autoComplete="off"
            value={value}
            onChange={onChange}
            style={{backgroundColor: "" === errMsg ? "white" : "pink"}}
        />
        <br/>
        <span style={{color: "red"}} > {errMsg} </span>
    </>
    )
}

export default InputWithErrorMessage